import cssVariables from 'tfs.css-variables'

export default {
  tag: {
    marginRight: '1rem',
    marginBottom: '.25rem',
    fontSize: '0.875rem',
    display: 'inline-flex',
    alignItems: 'center',
    fontWeight: 'bold',
    transition: 'background-color 1s',

    '&:last-child': {
      marginRight: 0,
    },
  },
  new: {
    backgroundColor: 'orange',
  },
  hasError: {
    backgroundColor: cssVariables.colorRuby,
  },
  iconClose: {
    color: cssVariables.colorWhite,
    marginLeft: '.5rem',
  },
  toDelete: {
    backgroundColor: cssVariables.colorGrayC,
  },
  checkbox: {
    display: 'none',
  },
}
